import { ValidationMessage } from './../services/questionnaire/questionnaire.service';
import { HappitechResults } from '../pages/happitech/happitech-plugin.service';
import { RoutingLogic } from './engagement.model';
import { File } from '../services/questionnaire/questionnaire.service';

export type Operator = '>' | '<' | '==' | '!=' | '>=' | '<=';
export type MessageStatus = 'warning' | 'exclusion' | 'message';
export type ValidationType = 'warning' | 'exclusion' | 'message';

export enum QuestionTypes {
  MultipleChoiceQuestion = 'MultipleChoiceQuestion',
  SingleChoiceQuestion = 'SingleChoiceQuestion',
  RangeSliderQuestion = 'RangeSliderQuestion',
  TextQuestion = 'TextQuestion',
  NumberQuestion = 'NumberQuestion',
  EmailQuestion = 'EmailQuestion',
  Instruction = 'Instruction',
  DateTimeQuestion = 'DateTimeQuestion',
  TimeQuestion = 'TimeQuestion',
  YearQuestion = 'YearQuestion',
  DateQuestion = 'DateQuestion',
  HappyTechQuestion = 'HappyTechQuestion',
  PhotoQuestion = 'PhotoQuestion',
  VideoQuestion = 'VideoQuestion',
}

export class Question {
  public id: number;
  public type: QuestionTypes;
  public title: string;
  public titleHidden? = false;
  public subtitle: string;
  public description: string;
  public infoText: string;
  public userSelections: number[] = [];
  public minimum?: number;
  public maximum?: number;
  public defaultValue?: number;
  public minimumLabel?: string;
  public maximumLabel?: string;
  public minimumLength?: number;
  public maximumLength?: number;
  public step?: number;
  public userAnswer: string | number = null;
  public vitalsData: HappitechResults = null;
  public videoPhotoResult: File = null;
  public placeholder = '';
  public orientation = '';
  public dataLabel = '';
  public choices: Choice[] = [];
  public save: boolean;
  public mandatory: boolean;
  public routingLogic: RoutingLogic[] = [];
  public conditionalLogic? = '';
  public isAnswerValid? = true;
  public noVitals: boolean;
  public footer: string;
  public shortName: string;
  public allowVerify: boolean;
  public allowVerifyText: string;
  public overlay: string;
  public camera: string;
  public restrictVideoLength: boolean;
  public maxVideoTime: number; // TODO: should be min video time
  public hasInstructions: boolean;
  public questionInstructions: QuestionInstruction[] = [];
  public allowRecordingInstructions: boolean;
  public recordingInstructions: string;
  public isVideo: boolean;
  public isValid? = -1;
  public validationRules: ValidationRule[] | null;
  public uploaded: boolean; // true when answer is uploaded to BE, if answer is changed then it should become false again
  public uploading? = false;
  public decimalPlaces: number | null;
  public questionGroupId?: number;
  public currentErrorMessages?: string[] = [];
  public validationMessages?: ValidationMessage[] = [];
  public excluded? = false; // true when question is excluded by conditional logic
  public manualVideoPhotoUpload? = false; // true when the video/photo come from manual file upload
  public touched? = false; // true after user has interacted with the question
  public confirmQuestionSkip = false; // to show confirm skip alert for optional questions
  public dependentQuestionIds?: number[] = []; // list of question ids that are dependent (conditional logic) on this question
}

export enum InputModes {
  Decimal = 'decimal',
  Text = 'text',
  Numeric = 'numeric',
  Email = 'email',
}

export class QuestionGroup {
  public id: number;
  public name?: string;
  public questions: Question[] = [];
}

export enum PhotoOverlay {
  circle = 'circle',
  face = 'face',
  square = 'square',
  noOverlay = 'no_overlay',
}

export enum PhotoOrientation {
  landscape = 'landscape',
  portrait = 'portrait',
  notFixed = 'not_fixed',
}

export enum SliderOrientation {
  vertical = 'vertical',
  horizontal = 'horizontal',
}

export class Choice {
  public id: number;
  public text: string;

  public constructor(id: number, text: string) {
    this.id = id;
    this.text = text;
  }
}

export class QuestionInstruction {
  public id: number;
  public instructions: string;

  /* istanbul ignore next */
  public constructor(id: number, instructions: string) {
    this.id = id;
    this.instructions = instructions;
  }
}

export class FieldValidation {
  public id: number;
  public message: string;
  public operator: string;
  public validationType: string;
  public value: string;
  /* istanbul ignore next */
  public constructor(id: number, message: string, operator: string, validationType: string, value: string) {
    this.id = id;
    this.message = message;
    this.operator = operator;
    this.validationType = validationType;
    this.value = value;
  }
}

export interface ValidationRule {
  type: MessageStatus;
  value: string;
  operator: Operator;
  text: string;
  id: number;
}
